/**
 * getMediaPlayer function
 * @returns {string} A string representing the positions and providers of the media players found, or 'none' if there are none.
 */
export function getMediaPlayer(): string {
	const mediaPlayer: string[] = []
	const medias = [...document.querySelectorAll('[data-ads-core]')]
	medias.forEach((item) => {
		const dataAdsCore = JSON.parse(item.getAttribute('data-ads-core') || 'null')
		const playerPosition =
			dataAdsCore?.playerPosition === 'Autre' ? 'embedded' : dataAdsCore?.playerPosition
		const playerProvider = dataAdsCore?.playerProvider
		if (playerPosition && playerProvider) {
			mediaPlayer.push(`${playerPosition.toLowerCase()}${playerProvider}`)
		}
	})
	return mediaPlayer.length === 0 ? 'none' : mediaPlayer.join(',')
}
